import React from "react";
import CarouselItem from "./CarouselItem";

import Carousel from "@brainhubeu/react-carousel";
import "@brainhubeu/react-carousel/lib/style.css";
import { makeStyles } from "@material-ui/core/styles";

const handleDragStart = (e) => e.preventDefault();

const items = [
  <img
    src="path-to-img"
    onDragStart={handleDragStart}
    className="yours-custom-class"
  />,
  <img
    src="path-to-img"
    onDragStart={handleDragStart}
    className="yours-custom-class"
  />,
  <img
    src="path-to-img"
    onDragStart={handleDragStart}
    className="yours-custom-class"
  />,
];
const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      width: "100vw",
    },
  },
}));
const SliderCarousel = ({ data }) => {
  const classes = useStyles();

  const SliderItems = data?.map((item, index) => {
    return <CarouselItem key={index} data={item} />;
  });
  const [value, setValue] = React.useState(0);
  const onChange = (e) => {
    setValue(e);
  };

  return (
    <div className={classes.root}>
      <Carousel
        slidesPerPage={1}
        animationSpeed={1500}
        autoPlay={9000}
        stopAutoPlayOnHover
        infinite
        slides={SliderItems}
        clickToChange
        value={value}
        onChange={(e) => onChange(e)}
      />
    </div>
  );
};
export default SliderCarousel;

// import React from "react";
// import AliceCarousel from "react-alice-carousel";
// import "react-alice-carousel/lib/alice-carousel.css";
// import CarouselItem from "./CarouselItem";

// const handleDragStart = (e) => e.preventDefault();

// const items = [
//   <img
//     src="path-to-img"
//     onDragStart={handleDragStart}
//     className="yours-custom-class"
//   />,
//   <img
//     src="path-to-img"
//     onDragStart={handleDragStart}
//     className="yours-custom-class"
//   />,
//   <img
//     src="path-to-img"
//     onDragStart={handleDragStart}
//     className="yours-custom-class"
//   />,
// ];

// const SliderCarousel = ({ data }) => {
//   const SliderItems = data?.map((item, index) => {
//     return <CarouselItem key={index} data={item} />;
//   });

//   return (
//     <AliceCarousel
//       autoPlay
//       disableButtonsControls
//       disableDotsControls
//       infinite
//       autoPlayInterval={6000}
//       mouseTracking
//       items={SliderItems}
//       responsive={{
//         0: {
//           items: 1,
//         },
//         1024: {
//           items: 1,
//           autoPlayInterval: 6000,
//         },
//       }}
//     />
//   );
// };
// export default SliderCarousel;
